import Image from 'next/image';
import { staticCdnHost } from '@rockalingua/ui/constants/Cdn';

import { ImageContainer } from './FAQsImage.styled';

export default function FAQsImage() {
  return (
    <ImageContainer>
      <Image
        src={`${staticCdnHost}/img/pricing/FAQs-image.svg`}
        alt="Ask us anything"
        width={455}
        height={475}
      />
    </ImageContainer>
  );
}
